const guideGen6 = [
  "Escissia – Starter-Pokémon erhalten",
  "Route 2 – Erstes wildes Pokémon",
  "Nouvaria City – Kampf gegen Serena/Calem",
  "Route 3 & Aquacorde – Trainerkämpfe",
  "Route 4 – Richtung Illumina City",
  "Illumina City – Professor Platan & Starter (Kanto)",
  "Route 5 – Richtung Vanitéa City",
  "Vanitéa City – 1. Arena (Käfer)",
  "Route 6 & 7 – Palast, Relaxo-Event",
  "Route 8 – Fossilien & Pokémon fangen",
  "Relievera City – 2. Arena (Gestein)",
  "Route 10 – Team Flare Story",
  "Yantara City – 3. Arena (Kampf)",
  "Mega-Ring erhalten & Mega-Entwicklung erklärt",
  "Route 11 & Reflexion Cave",
  "Romantia City – 4. Arena (Fee)",
  "Route 14 – Team Flare Event",
  "Illumina City Rückkehr – 5. Arena (Elektro)",
  "Route 12 – Lapras erhalten",
  "Azuria City – 6. Arena (Psycho)",
  "Route 13 – Kraftwerk & Team Flare aufhalten",
  "Fluxia City – 7. Arena (Eis)",
  "Route 19 – Kämpfe & Story-Event",
  "Fractalia City – 8. Arena (Drache)",
  "Team Flare HQ – Storyfinale & Xerneas/Yveltal",
  "Route 18 & Pokémon Village",
  "Pokémon-Liga – Siegesstraße",
  "Top 4 & Champ Diantha",
];

export default guideGen6;
